// Native
import { useEffect, useState } from "react"
import { Badge, FormatNumber, Grid, GridItem, HStack, Table, Text } from "@chakra-ui/react"
import moment from "moment"

// Custom
import { Parts, UI } from "components"
import { Styles } from "config"
import useBonusList from "hooks/useBonusList"
import { Mask } from "config"

export default function Bonus(){

    const initial_period = [moment().subtract('months', 10).toDate(), moment().toDate()]
    const [ period, setPeriod ] = useState(initial_period)

    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState('')
    const bonus = useBonusList(page, term)
    
    const columns = [{ children: 'Descrição' }, { children: 'Consultor' }, { children: 'Valor', textAlign: 'right' }, { children: 'Data', textAlign: 'right' }]

    useEffect(() => { setPage(1) }, [term])

    return(
    <>
    <UI.Header title="Bonificações" />

    <Grid templateColumns={{ lg: '1fr 1fr 1fr', md: '1fr 1fr', sm: '1fr' }} gap={4} mb={4}>

        {/* Resumo */}
        <GridItem><Parts.Widgets.Bonus.Resume /></GridItem>

        {/* Detalhes */}
        <GridItem><Parts.Widgets.Bonus.Details /></GridItem>

        {/* Pagamento de terceiros */}
        <GridItem><Parts.Widgets.Third /></GridItem>

    </Grid>
    
    <Text color="GrayText" my={4}>Histórico de bonificação:</Text>
    <UI.Searchable placeholder="Procurar pelo código do pedido..." value={term} onChange={setTerm} disabled={bonus.isFetching} />
    <UI.Table columns={columns} data={bonus.data?.data} meta={bonus.data?.meta} loading={bonus.isFetching} loadingText="Carregando histórico de bonificações..." Row={Row} onPageChange={e => setPage(e.page)}>
        
    </UI.Table>

    </>
    )
}

const Row = ({ data }) => {
    const operation = Styles.bonusOperation(data.operation)

    return(
    <Table.Row key={data.id}>
        <Table.Cell fontSize="xs">
            <HStack>
                <Text>{data?.label}</Text>
                <UI.Show visible={data?.order}><Text>({data?.order?.cod})</Text></UI.Show>
                <UI.Show visible={data?.type==1}><Badge size="xs" colorPalette="gray">Rede</Badge></UI.Show>
                <UI.Show visible={data?.type==2}><Badge size="xs" colorPalette="purple">Pagamento de pedido</Badge></UI.Show>
                <UI.Show visible={data?.type==3}><Badge size="xs" colorPalette="red">Pedido de saque</Badge></UI.Show>
                <UI.Show visible={data?.type==4}><Badge size="xs" colorPalette="orange">Premiação</Badge></UI.Show>
                <UI.Show visible={data?.type==5}><Badge size="xs" colorPalette="gray">Remanejamento</Badge></UI.Show>
            </HStack>
        </Table.Cell>
        <Table.Cell fontSize="xs">{data?.order?.consultant?.customer?.name ?? <>&mdash;</>}</Table.Cell>
        <Table.Cell textAlign="right">
            <HStack justifyContent="flex-end">
                <UI.Tooltip content={data.operation_label}><Badge colorPalette={operation.colorPalette}><UI.Icon name={operation.icon} /></Badge></UI.Tooltip>
                <Text fontWeight="bold" color={`${operation.colorPalette}.focusRing`}><FormatNumber value={data.bonus / 100} style="currency" currency="BRL" /></Text>
            </HStack>
        </Table.Cell>
        <Table.Cell textAlign="right" color="GrayText">{Mask.dateTime(data?.created_at)}</Table.Cell>
    </Table.Row>
    )
}